window.crInitHeader = function (headerId, drawerId, options) {
  var header = document.getElementById(headerId);
  if (!header) return;

  options = options || {};

  var burger = header.querySelector('[data-cr-burger]');
  var drawer = document.getElementById(drawerId);
  var overlay = header.querySelector('[data-cr-overlay]');
  var closeBtn = header.querySelector('[data-cr-drawer-close]');

  if (burger && drawer && overlay) {
    function openDrawer() {
      drawer.classList.add('is-active');
      overlay.classList.add('is-active');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', 'Close menu');
      document.body.classList.add('cr-drawer-open');
    }

    function closeDrawer() {
      drawer.classList.remove('is-active');
      overlay.classList.remove('is-active');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', 'Open menu');
      document.body.classList.remove('cr-drawer-open');
    }

    function toggleDrawer() {
      var isOpen = burger.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeDrawer();
      } else {
        openDrawer();
      }
    }

    burger.addEventListener('click', toggleDrawer);
    overlay.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  // Keep cart bubble in sync with Shopify cart events, if the theme fires them.
  document.addEventListener('cart:updated', function (e) {
    var countEl = header.querySelector('[data-cr-cart-count]');
    if (countEl && e.detail && typeof e.detail.itemCount !== 'undefined') {
      countEl.textContent = e.detail.itemCount;
    }
  });

  if (options.predictiveEnabled) {
    crInitPredictiveSearch(header, options);
  }

  crInitHeaderScroll(header);
  crMakeHeaderUnhideable(header);
};

/**
 * Toggles `.is-scrolled` on the header as the page scrolls. This class is
 * what drives the "Scroll Animation" theme setting (Logo Zoom, Logo Zoom +
 * Header, Smooth Scale) in cr-header.css. It never changes `position`, so it
 * cannot cause the header to disappear or jump.
 */
function crInitHeaderScroll(header) {
  if (!header) return;

  var SCROLL_THRESHOLD = 12;
  var ticking = false;

  function applyScrollState() {
    header.classList.toggle('is-scrolled', window.scrollY > SCROLL_THRESHOLD);
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(applyScrollState);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  applyScrollState();
}

/**
 * Guarantees the header can never scroll out of view, regardless of what any
 * ancestor element elsewhere in the theme does (overflow, clip, transform,
 * etc. on a parent can silently break plain CSS `position: sticky`, and did
 * on this site).
 *
 * This measures the header's own natural position in the page once (its
 * distance from the very top of the document — normally just the height of
 * whatever sits above it, like an announcement bar). As soon as the page is
 * scrolled past that point, the header is switched to `position: fixed` and
 * pinned to the top, and a spacer exactly matching the header's current
 * rendered height is shown in its place so the page never jumps. Scrolling
 * back up above that point reverses it automatically.
 *
 * A ResizeObserver keeps the spacer's height in sync with the header's own
 * height at all times (not just on scroll) — this matters because the
 * "Logo Zoom + Header" scroll animation compacts the header's padding once
 * scrolled, which changes its height.
 */
function crMakeHeaderUnhideable(header) {
  if (!header) return;

  var startOffset = null;
  var ticking = false;

  var spacer = document.createElement('div');
  spacer.className = 'cr-header__spacer';
  spacer.setAttribute('aria-hidden', 'true');
  header.insertAdjacentElement('afterend', spacer);

  function isPinned() {
    return header.classList.contains('cr-header--pinned');
  }

  function captureStartOffset() {
    if (isPinned()) return; // header is fixed right now, its rect no longer reflects the flow position
    startOffset = header.getBoundingClientRect().top + window.scrollY;
  }

  function syncSpacerHeight() {
    spacer.style.height = header.getBoundingClientRect().height + 'px';
  }

  function update() {
    if (startOffset === null) captureStartOffset();

    var shouldPin = window.scrollY > startOffset;

    if (shouldPin !== isPinned()) {
      header.classList.toggle('cr-header--pinned', shouldPin);
      spacer.classList.toggle('is-active', shouldPin);
    }

    if (shouldPin) syncSpacerHeight();

    ticking = false;
  }

  function onScrollOrResize() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', function () {
    if (!isPinned()) captureStartOffset();
    onScrollOrResize();
  });
  window.addEventListener('load', function () {
    if (!isPinned()) captureStartOffset();
  });

  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(function () {
      if (isPinned()) syncSpacerHeight();
    });
    ro.observe(header);
  }

  captureStartOffset();
  update();
}

function crFormatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');
    if (isNaN(number) || number == null) return '0';
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var cents2 = parts[1] ? decimal + parts[1] : '';
    return dollars + cents2;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
}

function crInitPredictiveSearch(header, options) {
  var forms = header.querySelectorAll('[data-cr-search-form]');
  if (!forms.length) return;

  forms.forEach(function (form) {
    var input = form.querySelector('[data-cr-search-input]');
    var resultsBox = form.querySelector('[data-cr-search-results]');
    if (!input || !resultsBox) return;

    var debounceTimer = null;
    var currentController = null;

    function closeResults() {
      resultsBox.hidden = true;
      resultsBox.innerHTML = '';
    }

    function renderResults(data, query) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      var queries = (data.resources && data.resources.results && data.resources.results.queries) || [];

      if (!products.length && !queries.length) {
        resultsBox.innerHTML = '<div class="cr-search-empty">No results for "' + query + '"</div>';
        resultsBox.hidden = false;
        return;
      }

      var html = '';

      if (queries.length) {
        html += '<ul class="cr-search-suggestions">';
        queries.slice(0, 5).forEach(function (q) {
          html += '<li><a href="' + q.url + '" class="cr-search-suggestion">' + q.styled_text + '</a></li>';
        });
        html += '</ul>';
      }

      if (products.length) {
        html += '<ul class="cr-search-products">';
        products.forEach(function (p) {
          var img = p.featured_image ? p.featured_image.url : '';
          var price = crFormatMoney(p.price, options.moneyFormat);
          html += '' +
            '<li class="cr-search-product">' +
              '<a href="' + p.url + '" class="cr-search-product__link">' +
                (img ? '<img class="cr-search-product__img" src="' + img + '" alt="" width="48" height="48">' : '<span class="cr-search-product__img cr-search-product__img--empty"></span>') +
                '<span class="cr-search-product__info">' +
                  '<span class="cr-search-product__title">' + p.title + '</span>' +
                  '<span class="cr-search-product__price">' + price + '</span>' +
                '</span>' +
              '</a>' +
            '</li>';
        });
        html += '</ul>';
      }

      html += '<a href="' + options.searchUrl + '?q=' + encodeURIComponent(query) + '" class="cr-search-viewall">View all results for "' + query + '"</a>';

      resultsBox.innerHTML = html;
      resultsBox.hidden = false;
    }

    function fetchResults(query) {
      if (currentController) currentController.abort();
      currentController = new AbortController();

      var limit = options.resultLimit || 5;
      var url = options.predictiveUrl + '.json' +
        '?q=' + encodeURIComponent(query) +
        '&resources[type]=product,query' +
        '&resources[limit]=' + limit +
        '&resources[options][unavailable_products]=last' +
        '&section_id=predictive-search';

      fetch(url, { signal: currentController.signal })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          renderResults(data, query);
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') closeResults();
        });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        closeResults();
        return;
      }

      debounceTimer = setTimeout(function () {
        fetchResults(query);
      }, 300);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && resultsBox.innerHTML) {
        resultsBox.hidden = false;
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) closeResults();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeResults();
    });
  });
}